module.exports = __webpack_public_path__ + "static/img/home8.2b364db0.jpg";